import Vue from 'vue';
import layer from 'common/lib/layer/layer';

Vue.directive('tips', {
  inserted: function (el, {value}) {
    var msg = null;
    if (typeof value === "string") {//<input v-tips="'xxx'">
      msg = value;
    } else if (typeof value === "object") {// <div v-tips="{msg:'xxx'}">
      msg = value.msg;
    }

    var layerIndex = null;
    $(el).mouseover(function () {
      layerIndex = layer.tips(msg, el, {tips: [1, '#3595CC'],time: 3000});
    }).mouseout(function(){
      layer.close(layerIndex);
    });
  }
})



// WEBPACK FOOTER //
// ./src/common/js/directive/tips-directive.js